import React, { Component } from "react";
import { Redirect } from "react-router";
import "./ModelSelector.scss";
import modelsJSON from "../../data/models.json";
import TypeCarFilter from "./TypeCarFilter";
import SelectModel from "./selectModel/SelectModel";
import sendEventoGTM from "../../utils/tags";

export default class ModelSelector extends Component {
  constructor() {
    super();
    this.state = {
      type: "all",
      listOfModels: modelsJSON,
      modelsOptions: [
        { value: "all", name: "Todos" },
        { value: 1, name: "SUV y 4x4" },
        { value: 2, name: "Familiar" },
        { value: 3, name: "Urbano" },
        { value: 4, name: "Comercial" },
        { value: 5, name: "Deportivo" },
        { value: 6, name: "Híbrido" }
      ],
      disabledLink: true,
      isHibryd: false
    };
  }

  componentWillMount() {
    this.props.setAppBarState(2, 1, 0, 0);
  }

  componentDidMount() {
    this.scrollToTop();
    this.props.resetModels();
    // Model Selected/ Model
    sendEventoGTM(
      "4-model-search",
      "0"
    );
  }

  scrollToTop = () => {
    if (window.innerWidth <= 425) {
      let elmnt = document.getElementById("model-title");
      elmnt && elmnt.scrollIntoView();
    }
  };

  carTypeSelect = type => {
    this.setState({ ...this.state, type });
  };

  getSelectValue = e => {
    const { value } = e.target;
    if (value !== "all") {
      this.setState({ ...this.state, type: parseInt(value) });
    } else {
      this.setState({ ...this.state, type: value });
    }
  };

  render() {
    if (this.props.redirectToInit) {
      return <Redirect to="/" />;
    }
    if (this.props.redirectToCalculator) return <Redirect to="/calculator" />;
    if (this.state.type)
      return this.state.listOfModels ? (
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 mobile-cars-container">
              <div className="title">
                <h3 id="model-title" className="small-title text-center">
                  Escoge un tipo de vehículo
                </h3>
              </div>
              {/* <TypeCarFilter
                carTypeSelect={this.carTypeSelect}
                type={this.state.type}
              /> */}
              <div className="filter-container-mobile">
                <SelectModel
                  values={this.state.modelsOptions}
                  getSelectValue={this.getSelectValue}
                />
              </div>
              
              <div class="sugerencias-body">
                <div class="fondo-vehiculos">
                  <span class="contenedor row fondo-vehiculos">
                    {this.state.listOfModels.map((model, i) => {
                      return (
                        <div key={i} class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mosaico" onClick={() => { this.props.getModelSelect(model, this.state.type) }}>
                          <div class="imagen">
                            <div class="text-left">
                              <span class="cabecera-vehiculos col-md-12 col-lg-12">
                                <div class="row">
                                  <h2 class="col-md-4 col-lg-4">{model.nameCase}</h2>
                                  <h4 class="col-md-8 col-lg-8">
                                    
                                  </h4>
                                
                                  <hr class="col-md-12 col-lg 12" />
                                </div>
                              </span>
                              <img class="imagenes-vehiculos" src={model.image} alt={model.name} />
                            </div>
                            <div class="text-right"></div>
                          </div>
                        </div>
                      );
                    })}


                    {/* <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mosaico" routerLink="/segunda-mano/1387/lexus-ct">
                      <div class="imagen">
                        <div class="text-left">
                          <span class="cabecera-vehiculos col-md-12 col-lg-12">
                            <div class="row">
                              <h2 class="col-md-4 col-lg-4">CT</h2>
                              <h4 class="col-md-8 col-lg-8">
                                
                              </h4>
                             
                              <hr class="col-md-12 col-lg 12" />
                            </div>
                          </span>
                          <img class="imagenes-vehiculos" src="./images/mosaicos/ct.png" alt="Imagen mosaico Lexus CT" />
                        </div>
                        <div class="text-right"></div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mosaico" routerLink="/segunda-mano/3360/lexus-ux">
                      <div class="imagen">
                        <div class="text-left">
                          <span class="cabecera-vehiculos col-md-12 col-lg-12">
                            <div class="row">
                              <h2 class="col-md-4 col-lg-4">UX</h2>
                              <h4 class="col-md-8 col-lg-8">
                               
                              </h4>
                              
                              <hr class="col-md-12 col-lg 12" />
                            </div>
                          </span>
                          <img class="imagenes-vehiculos" src="./images/mosaicos/ux.png" alt="Imagen mosaico Lexus UX" />
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mosaico" routerLink="/segunda-mano/3562/lexus-uxe">
                      <div class="imagen">
                        <div class="text-left">
                          <span class="cabecera-vehiculos col-md-12 col-lg-12">
                            <div class="row">
                              <h2 class="col-md-4 col-lg-4">UX 300e</h2>
                              <h4 class="col-md-8 col-lg-8">
                                
                              </h4>
                              
                              <hr class="col-md-12 col-lg 12" />
                            </div>
                          </span>
                          <img class="imagenes-vehiculos" src="./images/mosaicos/ux300e.png" alt="Imagen mosaico Lexus UX 300e" />
                        </div>
                      </div>
                    </div>
                    
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mosaico" routerLink="/segunda-mano/1384/lexus-is">
                      <div class="imagen">
                        <div class="text-left">
                          <span class="cabecera-vehiculos col-md-12 col-lg-12">
                            <div class="row">
                              <h2 class="col-md-4 col-lg-4">IS</h2>
                              <h4 class="col-md-8 col-lg-8">
                              
                              </h4>
                              
                              <hr class="col-md-12 col-lg 12" />
                            </div>
                          </span>
                          <img class="imagenes-vehiculos" src="./images/mosaicos/is.png" alt="Imagen mosaico Lexus IS" />
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mosaico" routerLink="/segunda-mano/2070/lexus-nx">
                      <div class="imagen">
                        <div class="text-left">
                          <span class="cabecera-vehiculos col-md-12 col-lg-12">
                            <div class="row">
                              <h2 class="col-md-4 col-lg-4">NX</h2>
                              <h4 class="col-md-8 col-lg-8">
                               
                              </h4>
                              
                              <hr class="col-md-12 col-lg 12" />
                            </div>
                          </span>
                          <img class="imagenes-vehiculos" src="./images/mosaicos/nx.png" alt="Imagen mosaico Lexus NX" />
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mosaico" routerLink="/segunda-mano/3349/lexus-es">
                      <div class="imagen">
                        <div class="text-left">
                          <span class="cabecera-vehiculos col-md-12 col-lg-12">
                            <div class="row">
                              <h2 class="col-md-4 col-lg-4">ES</h2>
                              <h4 class="col-md-8 col-lg-8">
                               
                              </h4>
                              
                              <hr class="col-md-12 col-lg 12" />
                            </div>
                          </span>
                          <img class="imagenes-vehiculos" src="./images/mosaicos/es.png" alt="Imagen mosaico Lexus ES" />
                        </div>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mosaico" routerLink="/segunda-mano/3134/lexus-rc">
                      <div class="imagen">
                        <div class="text-left">
                          <span class="cabecera-vehiculos col-md-12 col-lg-12">
                            <div class="row">
                              <h2 class="col-md-4 col-lg-4">RC</h2>
                              <h4 class="col-md-8 col-lg-8">
                                
                              </h4>
                              
                              <hr class="col-md-12 col-lg 12" />
                            </div>
                          </span>
                          <img class="imagenes-vehiculos" src="./images/mosaicos/rc.png" alt="Imagen mosaico Lexus RC" />
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mosaico" routerLink="/segunda-mano/93/lexus-rx">
                      <div class="imagen">
                        <div class="text-left">
                          <span class="cabecera-vehiculos col-md-12 col-lg-12">
                            <div class="row">
                              <h2 class="col-md-4 col-lg-4">RX</h2>
                              <h4 class="col-md-8 col-lg-8">
                              
                              </h4>
                              
                              <hr class="col-md-12 col-lg 12" />
                            </div>
                          </span>
                          <img class="imagenes-vehiculos" src="./images/mosaicos/rx.png" alt="Imagen mosaico Lexus RX" />
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mosaico" routerLink="/segunda-mano/3351/lexus-rxl">
                      <div class="imagen">
                        <div class="text-left">
                          <span class="cabecera-vehiculos col-md-12 col-lg-12">
                            <div class="row">
                              <h2 class="col-md-4 col-lg-4">RXL</h2>
                              <h4 class="col-md-8 col-lg-8">
                                
                              </h4>
                              
                              <hr class="col-md-12 col-lg 12" />
                            </div>
                          </span>
                          <img class="imagenes-vehiculos" src="./images/mosaicos/rxl.png" alt="Imagen mosaico Lexus RXL" />
                        </div>
                      </div>
                    </div>
                    
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mosaico" routerLink="/segunda-mano/3190/lexus-lc">
                      <div class="imagen">
                        <div class="text-left">
                          <span class="cabecera-vehiculos col-md-12 col-lg-12">
                            <div class="row">
                              <h2 class="col-md-4 col-lg-4">LC</h2>
                              <h4 class="col-md-8 col-lg-8">
                                
                              </h4>
                              
                              <hr class="col-md-12 col-lg 12" />
                            </div>
                          </span>
                          <img class="imagenes-vehiculos" src="./images/mosaicos/lc.png" alt="Imagen mosaico Lexus LC" />
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mosaico" routerLink="/segunda-mano/3190/lexus-lc">
                      <div class="imagen">
                        <div class="text-left">
                          <span class="cabecera-vehiculos col-md-12 col-lg-12">
                            <div class="row">
                              <h2 class="col-md-4 col-lg-4">LC CABRIO</h2>
                              <h4 class="col-md-8 col-lg-8">
                               
                              </h4>
                              
                              <hr class="col-md-12 col-lg 12" />
                            </div>
                          </span>
                          <img class="imagenes-vehiculos" src="./images/models/lexus/lc-cabrio.png" alt="Imagen mosaico Lexus LC" />
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mosaico" routerLink="/segunda-mano/1379/lexus-ls">
                      <div class="imagen">
                        <div class="text-left">
                          <span class="cabecera-vehiculos col-md-12 col-lg-12">
                            <div class="row">
                              <h2 class="col-md-4 col-lg-4">LS</h2>
                              <h4 class="col-md-8 col-lg-8">
                               
                              </h4>
                              
                              <hr class="col-md-12 col-lg 12" />
                            </div>
                          </span>
                          <img class="imagenes-vehiculos" src="./images/mosaicos/ls.png" alt="Imagen mosaico Lexus LS" />
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mosaico" routerLink="/segunda-mano/1379/lexus-ls">
                      <div class="imagen">
                        <div class="text-left">
                          <span class="cabecera-vehiculos col-md-12 col-lg-12">
                            <div class="row">
                              <h2 class="col-md-4 col-lg-4">GS</h2>
                              <h4 class="col-md-8 col-lg-8">
                                
                              </h4>
                              
                              <hr class="col-md-12 col-lg 12" />
                            </div>
                          </span>
                          <img class="imagenes-vehiculos" src="./images/mosaicos/gs.png" alt="Imagen mosaico Lexus LS" />
                        </div>
                      </div>
                    </div> */}
                  </span>
                </div>
              </div>

              {/* <div className="car-list-container">
                {this.state.listOfModels.map((model, i) => {
                  return (
                    <div
                      key={i}
                      className={`car-item ${
                        this.state.type === "all"
                          ? ""
                          : model.familyFilter.includes(this.state.type)
                          ? ""
                          : "disabled"
                      }`}
                    >
                      <div
                        className="car-image"
                        onClick={
                          model.familyFilter.includes(this.state.type) ||
                          this.state.type === "all"
                            ? () => {
                                this.props.getModelSelect(
                                  model,
                                  this.state.type
                                );
                                // Model Selection
                                sendEventoGTM(
                                  "4-model-select",
                                  "0"
                                );
                              }
                            : null
                        }
                      >
                        <img src={model.image} alt={model.name} />
                      </div>
                      <div className="car-name">{model.nameCase}</div>
                    </div>
                  );
                })}
              </div> */}
            </div>
          </div>
        </div>
      ) : (
        <div />
      );
  }
}
